<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import FormFieldTemplateLarge from '../forms/FormFieldTemplateLarge.svelte';
  import CheckboxField from '../forms/CheckboxField.svelte';
  import MultiColumnFilterControl from './MultiColumnFilterControl.svelte';

  export let selectedTable;
  export let changeTable;

  export let checkLabel;
  export let filterLabel = null;
  export let field;
  export let filterField = null;
  export let testidBase = null;
</script>

{#key selectedTable?.name}
  <FormFieldTemplateLarge
    label={checkLabel}
    type="checkbox"
    labelProps={{
      onClick: () => {
        changeTable(selectedTable.name, table => ({ ...table, [field]: !table[field] }));
      },
    }}
  >
    <CheckboxField
      checked={!!selectedTable[field]}
      on:change={e => {
        changeTable(selectedTable.name, table => ({ ...table, [field]: e.target.checked }));
      }}
      data-testid={testidBase ? `${testidBase}_checkbox` : undefined}
    />
  </FormFieldTemplateLarge>
{/key}

{#if filterField && selectedTable?.[field]}
  <FormFieldTemplateLarge label={filterLabel} type="combo">
    <MultiColumnFilterControl
      compoudFilter={selectedTable?.[filterField]}
      onSetCompoudFilter={value => {
        changeTable(selectedTable.name, table => ({ ...table, [filterField]: value }));
      }}
      columnNames={selectedTable?.tableInfo?.columns?.map(col => col.columnName) || []}
    />
  </FormFieldTemplateLarge>
{/if}
